<script>
import config from "@/config";

const routes = [
  {
    path: "/",
    component: () => import("@/views/default/index.vue"),
    children: [
      {
        path: "/",
        redirect: "/login"
      },
      {
        path: "/login",
        component: () => import("@/views/default/_login.vue")
      },
      {
        path: "/logout",
        component: () => import("@/views/default/_logout.vue")
      },
      {
        path: "/expired",
        component: () => import("@/views/default/_expired.vue")
      },
      {
        path: "/denied",
        component: () => import("@/views/default/_denied.vue")
      },
      {
        path: "/firstTime",
        component: () => import("@/views/default/_firstTime.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/resetPassword",
        component: () => import("@/views/default/_resetPassword.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/security",
        component: () => import("@/views/default/_security.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/otp",
        component: () => import("@/views/default/_otp.vue"),
        meta: { requiredLoggedIn: true}
      }
    ]
  },
  {
    path: "/account",
    component: () => import("@/views/account/index.vue"),
    meta: { requiredLoggedIn: true },
    children: [
      {
        path: "/messages",
        component: () => import("@/views/account/_messages.vue"),
        meta: { requiredLoggedIn: true }
      },
      {
        path: "/settings",
        component: () => import("@/views/account/_settings.vue"),
        meta: { requiredLoggedIn: true }
      },
      {
        path: "/overview",
        component: () => import("@/views/account/_overview.vue"),
        meta: { requiredLoggedIn: true }
      },
      {
        path: "/accountListAlert",
        component: () => import("@/views/account/_accountListAlert.vue"),
        meta: { requiredLoggedIn: true }
      },
      {
        path: "/gameRules",
        component: () => import("@/views/account/_gameRules.vue"),
        meta: { requiredLoggedIn: true }
      },
    ]
  },
  {
    path: "/account",
    component: () => import("@/views/account/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account, config.accessRoles.editAccount, config.accessRoles.subAccount] },
    children: [
      {
        path: "/newAccount",
        component: () => import("@/views/account/_newAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.editAccount]}
      },
      {
        path: "/search",
        component: () => import("@/views/account/_search.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/subAccount",
        component: () => import("@/views/account/_subAccount.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subAccount]}
      },
      {
        path: "/accountList",
        component: () => import("@/views/account/_accountList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/partnerList",
        component: () => import("@/views/account/_partnerList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/partnerMarketList",
        component: () => import("@/views/account/_partnerMarketList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/partnerBetTypeList",
        component: () => import("@/views/account/_partnerBetTypeList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      },
      {
        path: "/viewDownline",
        component: () => import("@/views/account/_viewDownline.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account]}
      }
      // {
      //   path: "/accountListAlert",
      //   component: () => import("@/views/account/_accountListAlert.vue"),
      //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account] }
      // }
    ]
  },
  {
    path: "/logs",
    component: () => import("@/views/logs/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] },
    children: [
      {
        path: "/logs",
        redirect: "/accessLog"
      },
      {
        path: "/accessLog",
        component: () => import("@/views/logs/_accessLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/memberLog",
        component: () => import("@/views/logs/_memberLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/accountLog",
        component: () => import("@/views/logs/_accountLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/positionTakingLog",
        component: () => import("@/views/logs/_positionTakingLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/commissionLog",
        component: () => import("@/views/logs/_commissionLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/betLimitLog",
        component: () => import("@/views/logs/_betLimitLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/transactionLog",
        component: () => import("@/views/logs/_transactionLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
      },
      {
        path: "/accountActionLog",
        component: () => import("@/views/logs/_accountActionLog.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.accountActionLog] }
      }
    ]
  },
  {
    path: "/forecast",
    component: () => import("@/views/forecast/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast] },
    children: [
      {
        path: "/forecast",
        redirect: "/forecastHDPList"
      },
      {
        path: "/forecastHDPList",
        component: () => import("@/views/forecast/_forecastHDPList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      },
      {
        path: "/forecastHDPMMOList",
        component: () => import("@/views/forecast/_forecastHDPMMOList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      },
      {
        path: "/forecastOXTList",
        component: () => import("@/views/forecast/_forecastOXTList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      },
      {
        path: "/forecastOUList",
        component: () => import("@/views/forecast/_forecastOUList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      },
      {
        path: "/forecastOUMMOList",
        component: () => import("@/views/forecast/_forecastOUMMOList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      },
      {
        path: "/forecastOEList",
        component: () => import("@/views/forecast/_forecastOEList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      },
      {
        path: "/forecastDetails",
        component: () => import("@/views/forecast/_forecastDetails.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      },
      {
        path: "/forecastMMODetails",
        component: () => import("@/views/forecast/_forecastMMODetails.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.forecast]}
      }
    ]
  },
  {
    path: "/settlement",
    component: () => import("@/views/settlement/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlement] },
    children: [
      {
        path: "/settlement",
        redirect: "/settlementList"
      },
      {
        path: "/settlementList",
        component: () => import("@/views/settlement/_settlementList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlement]}
      }
    ]
  },
  {
    path: "/report",
    component: () => import("@/views/report/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] },
    children: [
      {
        path: "/report",
        redirect: "/settlementHistory"
      },
      {
        path: "/settlementHistory",
        component: () => import("@/views/report/_settlementHistory.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyStatementMember",
        component: () => import("@/views/report/_dailyStatementMember.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinlose",
        component: () => import("@/views/report/_dailyWinlose.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseDetail",
        component: () => import("@/views/report/_dailyWinloseDetail.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseByPlatformDetail",
        component: () => import("@/views/report/_dailyWinloseByPlatformDetail.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/dailyWinloseByMatchDetail",
        component: () => import("@/views/report/_dailyWinloseByMatchDetail.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/cancelledBetList",
        component: () => import("@/views/report/_cancelledBetList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/gameResult",
        component: () => import("@/views/report/_gameResult.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/gameResultDetail",
        component: () => import("@/views/report/_gameResultDetail.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/matchResult",
        component: () => import("@/views/report/_matchResult.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/systemParlay",
        component: () => import("@/views/report/_systemParlay.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/tournamentJackpot",
        component: () => import("@/views/report/_tournamentJackpot.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
      {
        path: "/tournamentRefundList",
        component: () => import("@/views/report/_tournamentRefundList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report]}
      },
    ]
  },
  {
    path: "/stock",
    component: () => import("@/views/stock/index.vue"),
    meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] },
    children: [
      {
        path: "/stock",
        redirect: "/betList"
      },
      {
        path: "/betListHDPOUDetails",
        component: () => import("@/views/stock/_betListHDPOUDetails.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListHDPOU",
        component: () => import("@/views/stock/_betListHDPOU.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListOXTOEMLDetails",
        component: () => import("@/views/stock/_betListOXTOEMLDetails.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListOXTOEML",
        component: () => import("@/views/stock/_betListOXTOEML.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListTG",
        component: () => import("@/views/stock/_betListTG.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListCS",
        component: () => import("@/views/stock/_betListCS.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListHTFT",
        component: () => import("@/views/stock/_betListHTFT.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListDC",
        component: () => import("@/views/stock/_betListDC.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListFGLG",
        component: () => import("@/views/stock/_betListFGLG.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betList",
        component: () => import("@/views/stock/_betList.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betList4d",
        component: () => import("@/views/stock/_betList4d.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/betListESports2",
        component: () => import("@/views/stock/_betListESports2.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/memberOutstanding",
        component: () => import("@/views/stock/_memberOutstanding.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      },
      {
        path: "/memberOutstanding4d",
        component: () => import("@/views/stock/_memberOutstanding4d.vue"),
        meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.stock] }
      }
    ]
  }
]

export default routes;
</script>
